
/*eslint-disable*/
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { common, commonApi, check } from "@/common/index";
import { mapState, mapActions } from "vuex";
import { validataNumber, validataDrawPwd } from "@/common/utils/validate.js";
export default {
name: "withdrawalDetail",
components: {
Confirm,
Group,
XInput,
XButton,
},
directives: {
TransferDom,
},
data() {
return {
showDelete: false,
amount: 0,
userBankId: "",
AvailBalance: "",
UUID: "",
minLimit: "",
bankInfo: "",
isReady: true,
showPass: false,
showPhone: false,
showInput: false, //弹出提款密码
password: "", //提款密码
};
},
computed: {
...mapState({
assetsInfoMap: (state) => state.userInfo.assetsInfoMap,
isLogin: (state) => state.isLogin,
customer_service_system_link: (state) =>
state.FrontConfigList.customer_service_system_link,
userInfo: (state) => state.userInfo.userInfo,
serverInfo: (state) => state.userInfo.serverInfo,
linkList: (state) => state.linkList,
}),
},
methods: {
...mapActions(["getFirstInfo"]),
haveComTotal(data, istype) {
this.$vux.toast.show({
text: data,
type: istype,
});
},
getminLimit() {
commonApi.HOMEAFTER.getminLimit({
UUID: this.UUID,
})
.then((data) => {
this.minLimit = data;
})
.catch((err) => {});
},
onCancel() {},
onConfirm() {

this.$router.replace({
path: "/Service",
});
},
passCancel() {
this.$router.go(-1);
},
passConfirm() {
this.$router.push({
path: "/My/AccountManat/WithdrawPasword",
});
},
phoneConfirm() {
this.$router.push({
path: "/My/AccountManat/mobileAuth",
});
},
deleteCard() {
this.$api.post(
this.$urls.PAY.deleteBank,
{
UUID: this.UUID,
bankId: this.userBankId,
},
(resp) => {
if (resp.data.code === 200) {
this.haveComTotal(
this.$t("mine").Withdrawal.Draw.deleteSucess,
"success"
);
let timer = setTimeout(() => {
this.$router.push({
path: "/My/Withdrawal/withdrawal",
});
clearTimeout(timer);
}, 1000);
} else {
this.haveComTotal(resp.data.msg, "cancel");
}
},
(err) => {}
);
},

handleApplyWithdraw() {
if (this.linkList.isWithdrawPassword === "1") this.showInput = true;
if (this.linkList.isWithdrawPassword === "0") this.applyWithdrawNew();
},
applyWithdrawNew() {
if (!this.checkForm()) return;
if (this.isReady) {
this.isReady = false;
let params = {
UUID: this.UUID,
amount: this.amount,
userBankId: this.userBankId,
};
if (this.linkList.isWithdrawPassword === "1")
params.withdrawPWD = this.password;
commonApi.PAY.applyWithdraw(params)
.then(() => {
this.haveComTotal(
this.$t("mine.Withdrawal.Draw.applySuccess"),
"success"
);
this.getFirstInfo();
setTimeout(() => {
this.isReady = true;
this.$router.push({
path: "/My/Wallet",
});
}, 1000);
})
.catch((err) => {
this.isReady = true;
this.haveComTotal(err, "cancel");
});
}
},
checkForm() {

if (!validataNumber(this.amount)) {
this.haveComTotal(
this.$t("mine.Withdrawal.Draw.check.amount1"),
"cancel"
);
return;
}

if (this.amount < this.minLimit) {
this.haveComTotal(
this.$t("mine.Withdrawal.Draw.drawTips1") +
this.minLimit +
this.$t("mine.Withdrawal.Draw.drawTips2"),
"cancel"
);
return;
}
if (this.amount > this.assetsInfoMap.AvailBalance) {
this.haveComTotal(
this.$t("mine.Withdrawal.Draw.check.amount2"),
"cancel"
);
return;
}

if (this.linkList.isWithdrawPassword === "1") {
if (!validataDrawPwd(this.password)) {
this.haveComTotal(this.$t("Forms.drawPwdError"), "cancel");
return;
}
}
return true;
},

ispassword() {
if (this.linkList.isWithdrawPassword === "1") {
if (!this.userInfo.withdrawPasswordValid) {
this.showPass = true;
}
}
},
},
created() {
this.bankInfo = this.$route.query;
this.userBankId = this.bankInfo.id;
this.UUID = this.$Cookies.get("UUID");
commonApi.PAY.withdrawGames()
.then((data) => {})
.catch((err) => {});
},
mounted() {
this.getminLimit();
this.ispassword();
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Withdrawal/bankDetail.vue